dcyAngular.internalDefine('devel/modules/components/search_bar/GroupSearchManager',["require","exports","./SearchManager"],function(require,exports,SearchManager_1){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=class extends SearchManager_1.SearchManager{constructor(attributes,tags){super(attributes,tags)}}});
//# sourceMappingURL=GroupSearchManager.js.map
;
